<template>
    <div class="part-pic-gif">
        <div :id="'guide' + timeId" class="game-guide" v-if="baseStr === 'svga'"></div>
        <Lottie class="lottie" :src="url" v-else-if="baseStr === 'json'" />
        <div v-else class="bubble"></div>
    </div>
</template>

<script>
import SVGA from "svgaplayerweb";
import { fileUrlBase } from '@/utils'
import Lottie from './Lottie.vue'
import { imageAdapter } from '@/utils/index'
export default {
    props: {
        url: {
            type: String,
            default: ''
        }
    },
    components: {
        Lottie
    },
    data() {
        return {
            timeId: Math.floor(new Date().getTime() * Math.random()),
            svgaUrlShow: this.url || "",
            baseStr: ''
        }
    },
    mounted() {
        this.$nextTick(() => {
            if (fileUrlBase(this.url) !== 'svga') return
            this.initPendantShow()
        });
    },
    watch: {
        url: {
            handler(value) {
                this.initPendantShow(value)
            },
            immediate: true
        }
    },
    methods: {
        initPendantShow(url) {
            const bubbleEle = document.querySelector('.image-adapter');
            if(bubbleEle) bubbleEle.remove()
            if (!url) return
            this.baseStr = fileUrlBase(url);
            switch (this.baseStr) {
                case "svga":
                    this.svgaUrlShow = url;
                    this.$nextTick(() => {
                        this.guideFn();
                    });
                    break;
                case "json":
                    console.log('lottie ');
                    break;
                default:
                    imageAdapter(url, '.bubble', 'image-adapter', this.$nextTick)
                    console.log('图片 img');
            }
        },

        guideFn() {
            // 获取id的dom元素
            const player = new SVGA.Player(`#guide${this.timeId}`);
            const parser = new SVGA.Parser(`#guide${this.timeId}`);
            this.svgaUrlShow = this.svgaUrlShow.replace('http:', 'https:')
            // this.svgaUrlShow = this.svgaUrlShow.replace('https://source.allosoft.top', '/cdn')

            parser.load(this.svgaUrlShow + '?', (videoItem) => {
                // 你的svga文件路径
                player.setVideoItem(videoItem);
                player.startAnimation(); // 开始动画
            });
        }
    },
}
</script>

<style lang="scss" scoped>
.part-pic-gif {
    position: relative;
    width: 100%;
    height: 100%;
}

.game-guide {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    overflow: hidden;
    pointer-events: none;
}

.bubble {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
}
.lottie {
    width: 100%;
    height: 100%;
}
</style>